module.exports = __webpack_public_path__ + "img/ArrowUp.18c6e3d6.png";